import { fetchGet } from 'api/common/callerHelpers';

export const getCreditScore = (ssn) => {
  if (!ssn) return false;
  return fetchGet('/api/borrowers/credit-score/' + ssn);
};
